import React from 'react';
import EditableCell from './EditableCell';
class ProductRow extends React.Component {
  onDelEvent() {
    this.props.onDelEvent(this.props.product.id);
  }

  render() {
    let amount = this.props.product.amount;
    let gstAmount = this.props.product.gstAmount;
    let totalAmount = this.props.product.totalAmount;

    return (
      <tr className='eachRow'>
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'slno',
            value: this.props.product.slno,
            id: this.props.product.id,
            readOnly: 'true',
            text: 'text-center',
            width: '40px',
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'text',
            name: 'description',
            value: this.props.product.description,
            id: this.props.product.id,
            width: '180px',
            required: true,
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'text',
            name: 'unit',
            value: this.props.product.unit,
            id: this.props.product.id,
            width: '90px',
            required: true,
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'qty',
            value: this.props.product.qty,
            id: this.props.product.id,
            width: '90px',
            min: '1',
            required: true,
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'rate',
            value: this.props.product.rate,
            id: this.props.product.id,
            width: '90px',
            step: '0.01',
            min: '0',
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'amount',
            //value: this.props.product.amount,
            value: amount,
            id: this.props.product.id,
            width: '90px',
            readOnly: 'true',
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'gst',
            value: this.props.product.gst,
            id: this.props.product.id,
            width: '90px',
            min: '0',
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'gstAmount',
            //value: this.props.product.gstAmount,
            value: gstAmount,
            id: this.props.product.id,
            width: '90px',
            readOnly: 'true',
          }}
        />
        <EditableCell
          onProductTableUpdate={this.props.onProductTableUpdate}
          cellData={{
            type: 'number',
            name: 'totalAmount',
            //value: this.props.product.totalAmount,
            value: totalAmount,
            id: this.props.product.id,
            width: '90px',
            readOnly: 'true',
          }}
        />
        <td className='del-cell'>
          <span className='table-delete' onClick={this.onDelEvent.bind(this)}>
            <button
              className='text-danger pointer link-button'
              data-toggle='tooltip'
              title='Delete row!'
              style={{ cursor: 'pointer' }}
            >
              <i className='fa fa-trash-o fa-1.5x' aria-hidden='true'></i>
            </button>
          </span>
        </td>
      </tr>
    );
  }
}
export default ProductRow;
